import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "../../../components/ui/button";
import { Input } from "../../../components/ui/input";
import { Label } from "../../../components/ui/label";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "../../../components/ui/select";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "../../../components/ui/dialog";
import { API } from "../../../App";

export default function PilotMergeDialog({ source, candidates, onClose, onMerged }) {
  const [targetId, setTargetId] = useState("");
  const [busy, setBusy] = useState(false);
  const target = candidates.find((p) => p.id === targetId);

  const submit = async () => {
    if (!targetId) { toast.error("Escolhe o piloto de destino."); return; }
    if (!window.confirm(`Fundir "${source.name}" em "${target?.name}"?\n\nTodos os voos do piloto avulso (incluindo voos onde aparece como companheiro) vão passar para o piloto destino. O piloto avulso será apagado.`)) return;
    setBusy(true);
    try {
      const r = await axios.post(`${API}/di/pilots/${source.id}/merge-into/${targetId}`, {}, { withCredentials: true });
      const d = r.data;
      toast.success(`Fundido ${d.moved_own_flights} voo(s) + ${d.moved_companion_refs} referência(s) como companheiro. Avulso apagado.`);
      onMerged();
    } catch (e) { toast.error(e?.response?.data?.detail || "Erro a fundir pilotos"); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="bg-slate-900 border-slate-700 max-w-md" data-testid="di-pilot-merge-dialog">
        <DialogHeader>
          <DialogTitle className="text-white">Fundir piloto</DialogTitle>
          <DialogDescription className="text-slate-400">Move todo o histórico de voos de <strong className="text-purple-300">{source.name}</strong> para outro piloto existente. O piloto avulso é apagado no fim.</DialogDescription>
        </DialogHeader>
        <div className="space-y-2 text-xs">
          <Label className="text-slate-300">Piloto de destino *</Label>
          <Select value={targetId} onValueChange={setTargetId}>
            <SelectTrigger className="bg-slate-800 border-slate-700" data-testid="di-pilot-merge-target"><SelectValue placeholder={candidates.length ? "Escolher piloto..." : "Sem outros pilotos disponíveis"} /></SelectTrigger>
            <SelectContent className="bg-slate-900 border-slate-700 max-h-72">{candidates.map((p) => <SelectItem key={p.id} value={p.id}>{p.name} · {p.license_type || "PU"} {p.pu_number}{p.kind === "student" ? " (aluno)" : p.kind === "avulso" ? " (avulso)" : ""}</SelectItem>)}</SelectContent>
          </Select>
          {target && <div className="mt-2 p-2 rounded border border-purple-700/30 bg-purple-500/5 text-purple-200/90 text-[11px]"><strong>{source.name}</strong> ({source.flight_stats?.flights || 0} voos) →&nbsp;<strong>{target.name}</strong> ({target.flight_stats?.flights || 0} voos)</div>}
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose} disabled={busy}>Cancelar</Button>
          <Button onClick={submit} disabled={busy || !targetId} className="bg-purple-600 hover:bg-purple-500" data-testid="di-pilot-merge-submit">{busy ? "A fundir..." : "Fundir"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
